import {Organization} from '@catalyst-zero/company-schema/types/Organization'
import axios from 'axios'

import {ORGANIZATIONS_API_PREFIX} from '../utils/constants'

export const getOrganization = async (organizationId: string): Promise<Organization> => {
  const organizationResponse = await axios.get<Organization>(
    `${ORGANIZATIONS_API_PREFIX}/organizations/${organizationId}`
  )
  return organizationResponse.data
}
